import { createSelector } from 'reselect'
import { parseURLParams } from '@offerzen/pinata'

export const getLocation = state => state.router.location
export const urlParams = createSelector([getLocation], ({ search }) => parseURLParams(search))
